import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (props) => {
  const location = useLocation();

  useEffect(() => {
  //   const timer = setTimeout(() => {
  //   window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  // }, 100); 
  // return () => clearTimeout(timer);
  if (location.hash === "") {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }
}, [location]); // Run the effect every time the location changes.

  return <>{props.children}</>;
};

export default ScrollToTop;
